var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.ready)?_c('v-chip',_vm._b({staticClass:"font-weight-bold",attrs:{"label":"","text-color":"white","color":_vm.healthUtil.colorForStatus(_vm.rdata.status)}},'v-chip',_vm.$attrs,false),[_vm._v(_vm._s(_vm.statusText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }